export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

function checkValidServiceWorker(swUrl: $TSFixMe, config: $TSFixMe) {
  fetch(swUrl)
    .then((response) => {
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      window.console.log(
        'No internet connection found. App is running in offline mode.'
      )
    })
}

function registerValidSW(swUrl: $TSFixMe, config: $TSFixMe) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // eslint-disable-next-line no-param-reassign
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (installingWorker == null) {
          return
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration)
              }
            } else if (config && config.onSuccess) {
              // Execute callback
              config.onSuccess(registration)
            }
          }
        }
      }
    })
    .catch((error) => {
      window.console.error('Error during service worker registration:', error)
    })
}

export function register(config: $TSFixMe) {
  if (
    process.env.REACT_APP_ENVIRONMENT === 'production' &&
    'serviceWorker' in navigator
  ) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) {
      return
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config)
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config)
      }
    })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister()
    })
  }
}
